import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import AmoModal from "components/AmoModal";

/**
 * @param {object} props - object containing props for this component
 * @param {boolean} props.showModal - controls visibility of the modal
 * @param {number} props.year - year for the title
 * @param {Function} props.confirmButton - function triggered when closing the modal with Yes button
 * @param {Function} props.closeModal - function triggered when closing the modal
 * @returns - the Update Reconciliation modal, styled for the AMO project
 */
const ReconciliationUpdateModal = (props) => {
  const { showModal, year, confirmButton, closeModal } = props;
  const [isLoading, setIsLoading] = useState(false);
  return (
    <AmoModal
      data-testid="reconciliationUpdateModal"
      open={showModal}
      variant="default"
      title={`Update ${year}?`}
      width="35rem"
      showButton
      closePopover={() => closeModal()}
      buttonsLeftSpacer={1}
      buttons={[
        {
          key: "yesUpdate",
          label: "Yes",
          color: "primary",
          variant: "contained",
          width: "12rem",
          onClick: async () => {
            setIsLoading(true);
            try {
              await confirmButton();
              closeModal();
            } finally {
              setIsLoading(false);
            }
          },
          disabled: isLoading,
        },
        {
          key: "noUpdate",
          label: "No",
          color: "primary",
          variant: "outlined",
          width: "12rem",
          onClick: () => {
            closeModal();
          },
        },
      ]}
    >
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">{`Are you ready for ${year}’s audit? Any changes made to 2005-${year} after this point will need to be logged in this reconciliation table.`}</Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">Are you sure you wish to proceed?</Typography>
      <Grid item>&nbsp;</Grid>
    </AmoModal>
  );
};

ReconciliationUpdateModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  year: PropTypes.number.isRequired,
  confirmButton: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ReconciliationUpdateModal;
